import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveClinicNotification() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((notification) => {
    setSaving(true);
    return quarkusApi
      .post('/clinic-notifications', notification, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
